import { Routes } from '@angular/router';

import { roleHomeRedirectGuard } from '../@core/authentication/guards/role.guard';
import { adminRoleRoutes } from './admin/admin.routes';
import { checkerRoleRoutes } from './checker/checker.routes';
import { makerRoleRoutes } from './maker/maker.routes';

/** Role-scoped routes under the app shell in `app.routes.ts`. */
export const tenantFeatureRoutes: Routes = [
  ...adminRoleRoutes,
  ...makerRoleRoutes,
  ...checkerRoleRoutes,
  {
    path: '',
    pathMatch: 'full',
    canActivate: [roleHomeRedirectGuard],
    children: [],
  },
];
